(function () {
  var RATE = 1.38;
  var prices = document.querySelectorAll('.rm-price');
  var label = document.getElementById('rm-currency-label');
  var note = document.getElementById('rm-approx-note');
  var btnUsd = document.getElementById('rm-btn-usd');
  var btnCad = document.getElementById('rm-btn-cad');

  function render(currency) {
    prices.forEach(function (el) {
      var usd = parseFloat(el.getAttribute('data-usd'));
      if (isNaN(usd)) return;
      var val = currency === 'CAD' ? usd * RATE : usd;
      el.textContent = '$' + val.toFixed(2);
    });
    if (label) label.textContent = currency;
    if (note) note.style.display = currency === 'CAD' ? 'inline' : 'none';
    if (btnUsd) {
      btnUsd.style.background = currency === 'USD' ? '#DC9218' : 'transparent';
      btnUsd.style.color = currency === 'USD' ? '#1B2468' : '#6b6f8a';
    }
    if (btnCad) {
      btnCad.style.background = currency === 'CAD' ? '#DC9218' : 'transparent';
      btnCad.style.color = currency === 'CAD' ? '#1B2468' : '#6b6f8a';
    }
  }

  if (btnUsd) btnUsd.addEventListener('click', function () { render('USD'); });
  if (btnCad) btnCad.addEventListener('click', function () { render('CAD'); });
})();
